import { create } from "zustand";

const supportedLanguages = ["sv", "en"];

function resolveLanguage() {
  const storedLanguage = localStorage.getItem("language");

  return supportedLanguages.includes(storedLanguage) ? storedLanguage : "sv";
}

const useLanguageStore = create((set) => ({
  language: resolveLanguage(),

  setLanguage: (language) => {
    localStorage.setItem("language", language);
    set({ language });
  },
}));

export default useLanguageStore;
